
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stable/pragmatic-drag-and-drop",
      function () {
        return require("private-next-pages/stable/pragmatic-drag-and-drop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stable/pragmatic-drag-and-drop"])
      });
    }
  